{
  "common": {
    "appName": "Partake",
    "appDownloadPrompt": {
      "guest": "Tu aimes ce que tu vois? Retrouve Partake sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application Partake"
    },
    "postalCodeRequiredError": "Veuillez entrer un zip code"
  },
  "contact-information": {
    "title": "Ton Zip Code",
    "prompt": "Ajoute ton zip code afin de découvrir tout ce que tu peux emprunter près de chez toi !",
    "invalidAddressError": "Zip code invalide. Veuillez réessayer.",
    "changePostalCode": "Changer mon zip code"
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres de Partake est accessible par courriel et par messagerie. Nous te répondrons dans les plus brefs délais.",
    "faqLink": "https://www.we-partake.com/fr-us/about/frequently-asked-questions"
  },
  "free-sub": {
    "headerTextNotYet": "Vous contribuez à faire grandir le catalogue de <strong>Partake</strong> !"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser Partake pour vendre des objets."
  },
  "help": {
    "compensation": {
      "subscribeText": "Avec l'abonnement, Partake te dédommage jusqu'à 300 $ sur les objets prêtés et empruntés."
    }
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint Partake"
      }
    }
  },
  "introModal": {
    "pageTitle": {
      "newly_insured": "La Responsabilité Partake"
    },
    "titleNewFeature": "Partake est responsable !",
    "welcome": {
      "regular": "<strong>Bienvenue dans le Club !</strong>\nEn tant que membre officiel de Partake, ton abonnement te donne accès à de nouveaux avantages."
    },
    "custom": {
      "support": "<strong>Un bris ? Un souci ? Partake t’assure un service aux membres en tout temps.</strong>"
    }
  },
  "landing-page": {
    "immature": {
      "writeToMayor": {
        "title": "Demande à la ville d'offrir Partake à ses citoyen·ne·s"
      }
    }
  },
  "insured": {
    "landing-page": {
      "title": "Responsabilité Partake"
    },
    "listing": {
      "text": {
        "own": "Avec ton abonnement, tu profites de la Responsabilité Partake en cas de dommage à tes objets.",
        "other": "Avec son abonnement, {{name}} profite de la Responsabilité Partake en cas de dommage à ses objets."
      }
    },
    "myPlan": {
      "title": "Partake est responsable",
      "text": "En t’abonnant, tu profites de la Responsabilité Partake si un objet que tu prêtes ou empruntes est endommagé."
    },
    "profile": {
      "title": "{{name}} profite de la Responsabilité Partake en cas de dommage à ses objets."
    },
    "details": {
      "title": "Responsabilité Partake"
    }
  },
  "invite": {
    "referralProgram": {
      "title": "Tu aimes Partake ?\n<color>Pour chaque référence</color> nous t’offrons <color>1 mois gratuit !</color>",
      "details": "Chaque fois qu’un ami s’abonne avec ton lien de référencement, tu reçois 1 mois gratuit sur Partake.",
      "referrals": {
        "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partake grâce à <strong>toi</strong> 🥳",
        "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partake grâce à <strong>toi</strong> 🥳"
      },
      "gift": {
        "prefix": "Pour chaque personne référée, tu reçois automatiquement un mois gratuit sur Partake."
      },
      "shareText": "Salut !\n\nJ’utilise Partake, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "T'aimes Partake ?\n<color>Invite 5 personnes</color> et on t’offre <color>un cadeau d’une valeur de 25 $ !</color>",
      "shareText": "Salut !\n\nJ’utilise Partake, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}"
    },
    "shareText": "Salut !\n\nJ’utilise Partake, une app pour partager des objets du quotidien. C’est super pratique et je suis sûr·e que tu vas aimer. Rejoins-moi :\n\n{{url}}",
    "referrals": {
      "subTitle_one": "<strong>{{count}} personne</strong> a rejoint Partake grâce à <strong>toi</strong> 🥳",
      "subTitle": "<strong>{{count}} personnes</strong> ont rejoint Partake grâce à <strong>toi</strong> 🥳"
    }
  },
  "my-address": {
    "postalCodeFieldLabel": "Zip Code"
  },
  "my-neighbourhood": {
    "postalCodeLabel": "Zip Code"
  },
  "my-plan": {
    "businessPlan": {
      "title": {
        "municipal": "Abonnement Partake+",
        "municipal_closed": "Abonnement Partake+"
      }
    },
    "design": {
      "shareReferral": "Rejoins-moi sur Partake : {{url}}"
    },
    "freeSubText": {
      "trial": "Contribuez à faire grandir le catalogue de <strong>Partake</strong> ! Publiez 5 objets et gagnez votre <strong>abonnement annuel</strong> !"
    },
    "referralProgram": {
      "subtitle": "Pour chaque personne référée, tu obtiens automatiquement un mois gratuit sur Partake."
    }
  },
  "notifications": {
    "impactLevelExplorerMessage": "Commencez votre expérience Partake. Publiez un objet pour grandir votre impact et passer au niveau suivant.",
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvre Partake !"
      },
      "b2c_paid": {
        "body": "En tant que membre officiel de Partake, ton abonnement te donne accès à de nouveaux avantages."
      },
      "newly_insured": {
        "title": "Partake est responsable !"
      }
    },
    "newReferralSubscribed": {
      "receivedPrizeMessage": "Bravo ! 🥳 Vous venez de gagner un abonnement annuel gratuit au Partake !",
      "receivedMonthPrizeMessage": "Bravo ! 🥳 Vous venez de gagner un mois gratuit au Partake !"
    },
    "welcome": "Bienvenue sur Partake!",
    "rate": {
      "borrower": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partake."
      },
      "lender": {
        "message": "Votre avis est important pour nous et pour les autres membres de Partake."
      }
    }
  },
  "one-channel": {
    "firstLoanPrompt": {
      "description": "Ce premier emprunt t'est entièrement offert par Partake"
    },
    "notifNowInsured": "<strong>Sois sans crainte et partage !\n\nPartake peut te dédommager jusqu'à 300 $</strong> en cas de problème sur des articles prêtés, d'une valeur de 25 $ et plus.\n\nS’il arrive quoi que ce soit, tu peux nous contacter ici, ou bien par courriel à <strong>info@we-partake.com</strong>",
    "levelModal": {
      "superSharer": {
        "message": "Vous avez augmenté votre impact en réalisant 5 partages ! Vous accédez maintenant au niveau ultime : <strong>Super Partageur</strong> et un exemple à suivre sur Partake.\n\nBravo! À chaque partage, vous grandissez votre impact pour un avenir plus vert."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur Partake"
      }
    }
  },
  "payment": {
    "mobileRedirect": {
      "subtitle": "L'abonnement Partake est en ce moment disponible uniquement sur l'app mobile.\nUne fois abonné(e), vous pourrez continuer d'utiliser le site web pour emprunter et prêter des objets."
    }
  },
  "paywall": {
    "redesign": {
      "coverageFootnote": "*La Responsabilité Partake te dédommage jusqu'à 300 $ sur les objets prêtés ou empruntés."
    },
    "thirdFeature": "Partake est responsable des dommages causés aux objets"
  },
  "paywall2": {
    "offer": {
      "trial": "Obtiens 25 % de rabais sur l’abonnement annuel et profite pleinement de la Responsabilité Partake !"
    }
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenue sur Partake",
    "title": "Bienvenue sur Partake",
    "community": {
      "headerText": "Partake, c'est l'application de <strong>partage d'objets</strong> entre voisin.e.s."
    },
    "accessMore": {
      "headerText": "Sur Partake, tu accèdes à une <strong>abondance d'objets</strong>."
    },
    "offerMore": {
      "headerText": "Sur Partake, ta <strong>générosité</strong> fait une vraie <strong>différence</strong>."
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenue dans la communauté",
    "title": "Bienvenue dans la communauté",
    "newFlow": {
      "coverageFootnote": "*La Responsabilité Partake te dédommage jusqu'à 300 $ sur les objets prêtés ou empruntés."
    },
    "responsibility": {
      "headerText": "Partake est <strong>responsable</strong> !"
    },
    "transaction": {
      "headerText": "Sur Partake, il n’y a <strong>aucun échange d’argent</strong>"
    },
    "trust": {
      "headerText": "Sur Partake, la <strong>confiance</strong> passe <strong>avant tout</strong>"
    },
    "free": {
      "headerText": "Sur Partake, c’est 100% gratuit pour <strong>prêter</strong>"
    }
  },
  "privacy": {
    "link1": "https://www.we-partake.com/fr-us/terms-and-conditions",
    "link2": "https://www.we-partake.com/fr-us/privacy-policy",
    "button3Text": "Responsabilité de Partake",
    "link3": "https://www.we-partake.com/fr-us/terms-and-conditions#responsabilite"
  },
  "quick-new-thanks": {
    "bodyText": "Vous venez de contribuer à enrichir le catalogue de <strong>Partake</strong> !"
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter Partake"
    },
    "newRating": {
      "commentHelp": "Visible uniquement par l'équipe Partake. Utilise ce champ pour signaler un problème ou ajouter du contexte."
    }
  },
  "neighbour-profile": {
    "reviews": {
      "sheet": {
        "paragraph1": "Sur Partake, les évaluations permettent de bâtir une communauté de confiance pour des partages plus sûrs."
      }
    }
  },
  "trialPromo": {
    "title": "Contribuez à faire grandir le catalogue de Partake et gagnez votre abonnement !",
    "details": "Contribuez à faire grandir le catalogue de <strong>Partake</strong> ! Publiez 5 objets et gagnez votre <strong>abonnement annuel</strong> ! \uD83E\uDD73"
  },
  "tutorial": {
    "publishOffers": {
      "step1": {
        "text": "Ici, la <strong>confiance</strong> règne. Tous les membres s'engagent à respecter les règles d'or.\n\nEn cas de problème, <strong>l'équipe de Partake</strong> est à votre service en tout temps. (1/5)"
      }
    }
  },
  "ambassador": {
    "description": {
      "isAmbassador": "Un·e ambassadeur·rice est un membre engagé qui <strong>contribue activement à faire vivre le partage dans sa communauté</strong>. Il ou elle agit comme <strong>point de repère local</strong>, facilite les échanges et aide Partake à grandir, de façon humaine et authentique.",
      "notYetAmbassador": "Un·e ambassadeur·rice est un membre engagé qui <strong>contribue activement à faire vivre le partage dans sa communauté</strong>. Il ou elle agit comme <strong>point de repère local</strong>, facilite les échanges et aide Partake à grandir, de façon humaine et authentique."
    },
    "advantages": {
      "advantage3": {
        "body": "Donne ton avis sur les futures priorités et projets de Partake et du programme ambassadeur"
      },
      "advantage4": {
        "title": "Invitations spéciales événements Partake"
      },
      "advantage5": {
        "title": "Accès à des objets fourni par Partake"
      }
    },
    "mission": {
      "concrete1": "Faire connaître Partake autour de toi"
    }
  }
}
